import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import RedirectToLogin from '../../hooks/global/redirectToLogin';

// import { useAuth } from '../../contexts/auth/authContext';

const SECONDS_IN_MILLISECONDS = 1000;

export const isTokenExpired = (
  accessTokenExpirationDate: string | null,
): boolean => {
  if (accessTokenExpirationDate !== null) {
    const expirationDate: Date = new Date(accessTokenExpirationDate);

    const currentDateInSeconds = Date.now() / SECONDS_IN_MILLISECONDS;
    // Convert to this format Thu Sep 21 2023 08:17:39 GMT+0800
    const currentDate = new Date(
      currentDateInSeconds * SECONDS_IN_MILLISECONDS,
    );
    const isExpired = currentDate >= expirationDate; // Compare as milliseconds

    return isExpired;
  }

  return true;
};

const RequireCustomerAuth = () => {
  const userType = localStorage.getItem('user_type');
  const accessExpiration = localStorage.getItem('access_expiration');
  const refreshExpiration = localStorage.getItem('refresh_expiration');
  const location = useLocation();
  const navigate = useNavigate();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const refreshTokenExpired = isTokenExpired(refreshExpiration);
    // console.log('refresh token expired? ', refreshTokenExpired);
    if (userType == '1' && !refreshTokenExpired) {
      setChecked(true);
    } else {
      navigate('/login');
    }
  }, [
    location.pathname,
    navigate,
    userType,
    accessExpiration,
    refreshExpiration,
  ]);

  RedirectToLogin();

  // console.log('checked  flag is = ', checked);
  return <>{checked && <Outlet />}</>;
};

export default RequireCustomerAuth;
